import { atom } from 'recoil'
import { GeneralPortalSettings } from '../dataDefinitions/settings'

export const generalPortalSettings = atom<GeneralPortalSettings | null>({
    key: 'generalPortalSettings',
    default: null
})
